export default function (e) {
  if (window.Rollbar) {
    window.Rollbar.error(e)
    console && console.error(e)
    console && console.log('Error reported to rollbar')
  } else {
    console.error(e)
  }
}
